package pl.mothdigital.neuronowi

import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color
import pl.mothdigital.neuronowi.theme.SiteTheme

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = SiteTheme.white._900
    ctx.theme.palettes.light.color = SiteTheme.black._900
    ctx.theme.palettes.dark.background = SiteTheme.white._900
    ctx.theme.palettes.dark.color = SiteTheme.black._900
}
